import reduxForm from 'components/common/hoc/withFormErrorFocus'
import ProvidePhoneNumberForm from './ProvidePhoneNumberForm'
import { PROVIDE_PHONE_NUMBER_FORM } from './constants'
import validate from './validate'

export {
  PROVIDE_PHONE_NUMBER_FORM
}

export default reduxForm({
  form: PROVIDE_PHONE_NUMBER_FORM,
  validate,
  isModal: true
})(ProvidePhoneNumberForm)
